module.exports = __webpack_public_path__ + "phone.png";